import React from 'react'
import { useSelector } from 'react-redux'
import { localeCountryIsUK, localeCountryIsFrance } from '.'
import { selectLocale } from '../../store/locale/locale.selectors'

/* eslint-disable react/display-name */
export const withFrenchSite = Component => props => {
  const locale = useSelector(selectLocale)

  return localeCountryIsFrance(locale) ? <Component {...props} /> : null
}

export const withoutEnglishSite = Component => props => {
  const locale = useSelector(selectLocale)

  return !localeCountryIsUK(locale) ? <Component {...props} /> : null
}
